/*
 * @Author: 7
 * @Date: 2023-01-31 10:32:51
 * @LastEditTime: 2023-04-27 13:48:49
 * @FilePath: /sjtu-reference-canvas/src/page/EmailInfo.js
 */
/**
 * 问题反馈信息
 * 谢冉
 * 2020.8.25
 */
import '@instructure/canvas-theme';
import React, { useEffect, useState } from 'react';
import { instance } from '../axios';

function EmailInfo() {
  const [emailInfo, setEmailInfo] = useState();

  // 获取反馈问题邮箱信息
  useEffect(() => {
    instance({
      method: 'get',
      url: `queryEmailInfo`,
    })
      .then(res => {
        if (res.data.code === 0 && res.data.message === 'SUCCESS') {
          setEmailInfo(res.data.emailInfo);
        }
      })
      .catch(error => {
        console.log(error);
      });
  }, []);

  return (
    <div
      style={{
        color: '#8b969e',
        // position: 'absolute',
        // left: '44%',
        // bottom: '5%',
        textAlign: 'center',
        fontSize: '12px',
        padding: '10px',
        height: '40px',
      }}
    >
      {emailInfo}
    </div>
  );
}
export default EmailInfo;
